export default "__VITE_ASSET__DxKzlKs0__"